import I18n from '@/rI18n';
import * as yup from 'yup';
import Schema from '@/schema/Schema';
import BaseCustomSchema from './BaseCustomSchema';

const CreateTicketQAInChatbotSchema = fieldListData => {
    let validateObj = {};

    if (fieldListData) {
        validateObj = BaseCustomSchema(fieldListData);
    }

    validateObj[`mailAddress`] = yup
        .string()
        .required(I18n.get('COMMSG014'))
        .email(I18n.get('COMM01MSG07'))
        .max(200, I18n.get('COMMSG022').replace('{{maxLength}}', '200'))
        .trim();

    validateObj[`reEmailAddress`] = yup
        .string()
        .required(I18n.get('COMMSG014'))
        .email(I18n.get('COMM01MSG07'))
        .oneOf([Schema.ref('mailAddress'), null], I18n.get('COMMSG036'))
        .max(200, I18n.get('COMMSG022').replace('{{maxLength}}', '200'))
        .trim();

    validateObj[`lastName`] = yup
        .string()
        .max(128, I18n.get('COMMSG022').replace('{{maxLength}}', '128'))
        .trim();

    validateObj[`firstName`] = yup
        .string()
        .max(128, I18n.get('COMMSG022').replace('{{maxLength}}', '128'))
        .trim();

    validateObj[`lastNameKana`] = yup
        .string()
        .max(128, I18n.get('COMMSG022').replace('{{maxLength}}', '128'))
        .trim();

    validateObj[`firstNameKana`] = yup
        .string()
        .max(128, I18n.get('COMMSG022').replace('{{maxLength}}', '128'))
        .trim();

    validateObj[`formSelected`] = yup.string().required(I18n.get('COMMSG014'));

    return Schema.object().shape(validateObj);
};

export default CreateTicketQAInChatbotSchema;
